// extracted by mini-css-extract-plugin
export default {"sellPage":"Sell_sellPage__Ht8P5","submitButton":"Sell_submitButton__hIXv9"};